<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Work Order Supply Sub Contract" active>

                                <b-row v-if="hasFailedDataWorkOrderSupplySubContract">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedWorkOrderSupplySubContract.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="workOrderSupplySubContractsFailed" :fields="fieldsWorkOrderSupplySubContract" :busy="isDataLoading"
                                                         :sort-by.sync="sortByWorkOrderSupplySubContract" :sort-desc.sync="sortDescWorkOrderSupplySubContract" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(materialIssueDate)="row">
													{{ row.item.materialIssueDate | moment("DD-MMM-YYYY") }}
												</template>
												<template #cell(revisi)="row">
													{{ Number(row.item.revisi).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedWorkOrderSupplySubContract.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="workOrderSupplySubContracts" :fields="fieldsWorkOrderSupplySubContract" :busy="isDataLoading"
                                                         :sort-by.sync="sortByWorkOrderSupplySubContract" :sort-desc.sync="sortDescWorkOrderSupplySubContract" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(materialIssueDate)="row">
													{{ row.item.materialIssueDate | moment("DD-MMM-YYYY") }}
												</template>
												<template #cell(revisi)="row">
													{{ Number(row.item.revisi).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Work Order Supply Sub Contract Detail" active>

                                <b-row v-if="hasFailedDataWorkOrderSupplySubContractDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedWorkOrderSupplySubContractDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="workOrderSupplySubContractDetailsFailed" :fields="fieldsWorkOrderSupplySubContractDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByWorkOrderSupplySubContractDetail" :sort-desc.sync="sortDescWorkOrderSupplySubContractDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyOutstanding)="row">
													{{ Number(row.item.qtyOutstanding).toLocaleString() }}
												</template>
												<template #cell(stockVendor)="row">
													{{ Number(row.item.stockVendor).toLocaleString() }}
												</template>
												<template #cell(suggestQty)="row">
													{{ Number(row.item.suggestQty).toLocaleString() }}
												</template>
												<template #cell(actualQty)="row">
													{{ Number(row.item.actualQty).toLocaleString() }}
												</template>
												<template #cell(actualQtyPicking)="row">
													{{ Number(row.item.actualQtyPicking).toLocaleString() }}
												</template>
												<template #cell(qtyPo)="row">
													{{ Number(row.item.qtyPo).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedWorkOrderSupplySubContractDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="workOrderSupplySubContractDetails" :fields="fieldsWorkOrderSupplySubContractDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByWorkOrderSupplySubContractDetail" :sort-desc.sync="sortDescWorkOrderSupplySubContractDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyOutstanding)="row">
													{{ Number(row.item.qtyOutstanding).toLocaleString() }}
												</template>
												<template #cell(stockVendor)="row">
													{{ Number(row.item.stockVendor).toLocaleString() }}
												</template>
												<template #cell(suggestQty)="row">
													{{ Number(row.item.suggestQty).toLocaleString() }}
												</template>
												<template #cell(actualQty)="row">
													{{ Number(row.item.actualQty).toLocaleString() }}
												</template>
												<template #cell(actualQtyPicking)="row">
													{{ Number(row.item.actualQtyPicking).toLocaleString() }}
												</template>
												<template #cell(qtyPo)="row">
													{{ Number(row.item.qtyPo).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import WorkOrderSupplySubContract from '@/models/WorkOrderSupplySubContract/WorkOrderSupplySubContract';
import WorkOrderSupplySubContractList from '@/models/WorkOrderSupplySubContract/WorkOrderSupplySubContractList';
import WorkOrderSupplySubContractFilter from '@/filters/WorkOrderSupplySubContract/WorkOrderSupplySubContractFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsWorkOrderSupplySubContract: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Subcontract Purchase Order", key: 'purchaseOrderPurchaseOrderNumber', sortable: false},
				{"class" : "th-status", "label" : "Material Issue Date", key: 'materialIssueDate', sortable: false},
				{"class" : "th-status", "label" : "Revisi", key: 'revisi', sortable: false},
				{"class" : "th-status", "label" : "Work Order Supply Subcont Status", key: 'wosSubcontStatusName', sortable: false},
				{"class" : "th-status", "label" : "Vendor", key: 'vendorCode', sortable: false},
				{"class" : "th-status", "label" : "Remarks", key: 'remarks', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsWorkOrderSupplySubContractDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Part Number", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Qty PO Outstanding", key: 'qtyOutstanding', sortable: false},
				{"class" : "th-status", "label" : "Stock di Vendor", key: 'stockVendor', sortable: false},
				{"class" : "th-status", "label" : "Suggest Supply Qty", key: 'suggestQty', sortable: false},
				{"class" : "th-status", "label" : "Actual Supply Qty", key: 'actualQty', sortable: false},
				{"class" : "th-status", "label" : "Remarks", key: 'remarks', sortable: false},
				{"class" : "th-status", "label" : "Actual Qty Picking", key: 'actualQtyPicking', sortable: false},
				{"class" : "th-status", "label" : "Purchase Order Detail Id", key: 'purchaseOrderDetailId', sortable: false},
				{"class" : "th-status", "label" : "Qty PO", key: 'qtyPo', sortable: false},
				{"class" : "th-status", "label" : "Part Subcont", key: 'partSubcontPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Part Mapping Subcont", key: 'partMappingSubcontPart', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			workOrderSupplySubContracts : [],
			workOrderSupplySubContractsFailed: [],
			workOrderSupplySubContractId : '',
			sortByWorkOrderSupplySubContract: '',
			sortDescWorkOrderSupplySubContract: '',
			hasFailedDataWorkOrderSupplySubContract: false,
			totalFailedWorkOrderSupplySubContract: 0,
			totalSucceedWorkOrderSupplySubContract: 0,
			workOrderSupplySubContractDetails : [],
			workOrderSupplySubContractDetailsFailed: [],
			workOrderSupplySubContractDetailId : '',
			sortByWorkOrderSupplySubContractDetail: '',
			sortDescWorkOrderSupplySubContractDetail: '',
			hasFailedDataWorkOrderSupplySubContractDetail: false,
			totalFailedWorkOrderSupplySubContractDetail: 0,
			totalSucceedWorkOrderSupplySubContractDetail: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('workordersupplysubcontract/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('workordersupplysubcontract/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getWorkOrderSupplySubContractForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getWorkOrderSupplySubContractForUpload : async function() {
			let _this = this;
			this.$http.get('workordersupplysubcontract/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.workOrderSupplySubContracts = [];
_this.workOrderSupplySubContractDetails = [];


					if (response != null) {
						let result = response.data;
						_this.workOrderSupplySubContracts = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedWorkOrderSupplySubContract = _this.workOrderSupplySubContracts.length;

						_this.workOrderSupplySubContractsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataWorkOrderSupplySubContract = true;
						_this.totalFailedWorkOrderSupplySubContract = 0;
						if(_this.workOrderSupplySubContractsFailed == undefined || _this.workOrderSupplySubContractsFailed.length === 0) _this.hasFailedDataWorkOrderSupplySubContract = false;
						if(_this.hasFailedDataWorkOrderSupplySubContract) _this.totalFailedWorkOrderSupplySubContract = _this.workOrderSupplySubContractsFailed.length;
						_this.workOrderSupplySubContractDetails = [];
						_this.workOrderSupplySubContractDetailsFailed = [];
						_this.hasFailedDataWorkOrderSupplySubContractDetail = true;
						_this.totalSucceedWorkOrderSupplySubContractDetail = 0;
						result.forEach(function(element) {
							_this.workOrderSupplySubContractDetails.push(...element.workOrderSupplySubContractDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedWorkOrderSupplySubContractDetail = _this.workOrderSupplySubContractDetails.length;

							_this.workOrderSupplySubContractDetailsFailed.push(...element.workOrderSupplySubContractDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.workOrderSupplySubContractDetailsFailed == undefined || _this.workOrderSupplySubContractDetailsFailed.length === 0) _this.hasFailedDataWorkOrderSupplySubContractDetail = false;
							if(_this.hasFailedDataWorkOrderSupplySubContractDetail) _this.totalFailedWorkOrderSupplySubContractDetail = _this.workOrderSupplySubContractDetailsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'workordersupplysubcontract/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'WorkOrderSupplySubContract.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterWorkOrderSupplySubContract = new WorkOrderSupplySubContractFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
